import React from 'react';

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#050505',
        color: '#fff',
        fontFamily: 'Inter, system-ui, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        textAlign: 'center',
      }}
    >
      <img src="/logo.png" alt="Aperture Slate" style={{ height: '40px', marginBottom: '40px', opacity: 0.3 }} />

      <p style={{ fontSize: '11px', letterSpacing: '0.4em', color: '#00aaff', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '16px' }}>
        404 // Frame Not Found
      </p>

      <h1
        style={{
          fontSize: 'clamp(3rem, 12vw, 8rem)',
          fontWeight: '900',
          letterSpacing: '-0.04em',
          lineHeight: '0.9',
          textTransform: 'uppercase',
          margin: '0 0 8px 0',
        }}
      >
        404
      </h1>
      <h2
        style={{
          fontSize: 'clamp(1rem, 4vw, 2rem)',
          fontWeight: '900',
          letterSpacing: '-0.02em',
          textTransform: 'uppercase',
          color: '#333',
          margin: '0 0 40px 0',
        }}
      >
        Scene Missing
      </h2>

      <p style={{ color: '#555', fontSize: '1rem', lineHeight: '1.7', maxWidth: '400px', marginBottom: '48px' }}>
        This page doesn't exist or was moved. The slate rolls on — head back to the main site.
      </p>

      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a
          href="/#/"
          style={{
            padding: '16px 32px',
            background: '#fff',
            color: '#000',
            textDecoration: 'none',
            fontWeight: '800',
            fontSize: '0.75rem',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
          }}
        >
          Main Site
        </a>
        <a
          href="/#/tools"
          style={{
            padding: '16px 32px',
            background: 'transparent',
            color: '#fff',
            border: '1px solid #333',
            textDecoration: 'none',
            fontWeight: '800',
            fontSize: '0.75rem',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
          }}
        >
          Filmmaker Tools
        </a>
      </div>
    </div>
  );
}
